<template>
    <div id="app-header">
        <v-toolbar elevation="10" :color="$vuetify.theme.themes.dark.primary" dark height="unset" class="hidden-xs-only px-6">
            <router-link to="/" class="flex-grow-1">
                <img alt="#" :src="require('@/assets/logo.png')" height="52px" />
                <img alt="#" :src="getLogoUrl" style="position: relative; top:-10px;" height="32px" />
            </router-link>
            <v-spacer />
            <h2 class="pr-6">{{ $t('Модуль по работе с актами') }}</h2>
            <v-btn-toggle v-model="selectedLocale" dense light mandatory>
                <v-btn height="32px" class="px-6 py-2 font-weight-bold" v-for="locale in locales" :key="locale" :value="locale">
                    {{ locale }}
                </v-btn>
            </v-btn-toggle>
            <NotificationsMenu
                v-if="loggedIn"
                class="ml-4"
            />
        </v-toolbar>
        <v-toolbar elevation="10" :color="$vuetify.theme.themes.dark.primary" dark height="unset" class="hidden-sm-and-up px-container">
            <router-link to="/" class="flex-grow-1">
                <img alt="#" :src="require('@/assets/logo.png')" height="40px" class="mt-2" />
            </router-link>
            <v-spacer />
            <h5>{{ $t('Модуль по работе с актами') }}</h5>
        </v-toolbar>
        <div class="hidden-xs-only">
            <v-toolbar class="navigation-toolbar" style="overflow:hidden" :color="$vuetify.theme.themes.light.primary" light height="unset">
                <AppNavigation />
                <MenuItems menu_name="reports" :title="$t('Отчеты')" />
                <div class="d-flex ml-auto align-center flex-wrap flex-sm-nowrap">
                    <UserMenu />
                    <v-btn height="52" tile :title="$t('Вход в систему')" class="px-5 mr-9 toolbar-btn btn-signin" text dark to="/signin" v-if="!loggedIn">
                        <v-icon>person</v-icon>
                        {{ $t('Войти') }}
                    </v-btn>
                </div>
            </v-toolbar>
        </div>
        <v-toolbar class="hidden-sm-and-up px-container none_shadow" :color="$vuetify.theme.themes.dark.primary" dark dense>
            <ActionsMenu v-if="loggedIn" />
            <v-btn style="letter-spacing: 0.0292857143em; text-transform: unset;" height="48px" tile class=" toolbar-btn" text dark small @click="openMeters">
                <div class="mw120p">{{ UserHeaderValue }}</div>
            </v-btn>
            <div class="d-flex ml-auto align-center flex-wrap flex-xs-nowrap">
                <LanguageChanger />
                <v-btn height="48" tile :title="$t('Вход в систему')" class="toolbar-btn btn-signin" text dark to="/signin" v-if="!loggedIn" small>
                    <v-icon small>person</v-icon>
                    {{ $t('Войти') }}
                </v-btn>
                <v-btn icon small @click="logoutFromApplication" v-if="loggedIn" height="48" tile>
                    <v-icon small>exit_to_app</v-icon>
                </v-btn>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
import { LocaleService } from '@/services/storage.service';
import { mapActions, mapGetters } from 'vuex';
import AppNavigation from './AppNavigation';
import translate from '@/utils/translate.util';
import { truncate } from '@/utils/';
import LanguageChanger from '@/components/ui/LanguageChanger.vue';
import UserMenu from '@/components/ui/UserMenu.vue';
import ActionsMenu from '@/components/ui/ActionsMenu.vue';
import MenuItems from '@/components/layout/MenuItems.vue';
import NotificationsMenu from '@/components/notifications/NotificationsMenu.vue';

export default {
    name: 'AppHeader',
    components: {
        AppNavigation,
        LanguageChanger,
        UserMenu,
        ActionsMenu,
        MenuItems,
        NotificationsMenu
    },
    data() {
        return {
            locales: ['kz', 'ru'],
            selectedLocale: this.$i18n.locale
        };
    },
    watch: {
        selectedLocale(locale) {
            this.$i18n.locale = locale;
            LocaleService.setLocale(locale);
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
        async logoutFromApplication() {
            await this.logout();
        },
        openProfile() {
            this.$router.push('/profile');
        },
        openMeters() {
            this.$router.push(this.getNavigationItems[0].to);
        }
    },
    computed: {
        ...mapGetters('base', ['getNavigationItems']),
        getLogoUrl() {
            return require(`@/assets/ALTS_logo_${this.$i18n.locale}.png`);
        },
        loggedIn() {
            return this.$store.getters['auth/loggedIn'];
        },
        profileOptions() {
            return [
                { id: 'profile', name: this.$t('Профиль') },
                { id: 'logout', name: this.$t('Выход') }
            ];
        },
        servOrgName() {
            return truncate(
                translate(this.$store.state.users.servOrg, 'full', this.$i18n.locale).isas_serv_org_name || this.$store.state.users.servOrg.name,
                15
            );
        },
        UserHeaderValue() {
            return truncate(
                translate(this.$store.state.users.userHeader, 'full', this.$i18n.locale).header_value || this.$store.state.users.userHeader.header_value,
                15
            );
        }
    },
    created() {
        let locale = LocaleService.getLocale();
        if (!locale) {
            this.$i18n.locale = 'kz';
            LocaleService.setLocale('kz');
        }
    }
};
</script>

<style>
#app-header a {
    text-decoration: none;
    color: black;
}
#app-header .navigation-toolbar .v-toolbar__content {
    padding: 0 !important;
}
.lang-link_active {
    opacity: 0.5;
}

#list > .v-list-item:hover {
    background-color: #6b7bb2;
    font-weight: 500 !important;
}
.btn-signin:hover {
    background-color: #00628a;
    font-weight: 500 !important;
}
.btn-signin {
    font-weight: 300 !important;
    text-transform: capitalize;
}
.font-weight-medium-100 {
    font-weight: 300 !important;
}
.shadow-img {
    -webkit-filter: drop-shadow(2px 2px 2px #222);
    filter: drop-shadow(2px 2px 2px #222);
}
.none_shadow {
    box-shadow: none !important; /* remove box shadow */
}
</style>
